import './Header.sass';

import React, { FC, useContext } from 'react';
import { Link, useRoute } from 'react-router5';

import { IcBack28, IcClose28 } from '$assets';
import { HeaderProps } from '$uikit/Header/interface';
import { goBack, hasHistoryBack, hideModal } from '$navigation/helper';
import { useDesktop } from '$hooks';
import { ModalLink } from '$shared/components';
import { ModalContext } from '$shared/context';
import { classNames } from '$utils';

export const Header: FC<HeaderProps> = (props) => {
  const {
    showBackButton = false,
    showCloseButton = false,
    children,
    wide = false,
    leftContent = null,
    rightContent = null,
    rightIcons = null,
    rightLink = null,
    rightModal = null,
    routeName = null,
    routeParams = {},
    isSearch = false,
    isSecondaryBg = false,
    isTransparent = false,
    isPrimaryFg = false,
    backButtonOnClick,
    className,
  } = props;
  const { route } = useRoute();

  const handleBack = (e) => {
    e.stopPropagation();

    if (backButtonOnClick) {
      backButtonOnClick();
      return;
    }

    goBack();
  };
  const isDesktop = useDesktop();
  const isModal = useContext(ModalContext);

  function renderBack() {
    if (leftContent) {
      return leftContent;
    }

    if (!showBackButton && !showCloseButton) {
      return null;
    }

    return (
      <div className="Header__back" onClick={handleBack}>
        {showCloseButton || (isDesktop && isModal) ? <IcClose28 /> : <IcBack28 />}
      </div>
    );
  }

  function renderRightButton() {
    if (rightContent) {
      return rightContent;
    }

    if (!rightIcons) {
      return null;
    }

    let Component: any = 'div';
    let params: any = {};
    if (rightLink) {
      Component = Link;
      params.routeName = rightLink;
    } else if (rightModal) {
      Component = ModalLink;
      params.name = rightModal;
    }

    return (
      <Component className="Header__right" {...params}>
        {rightContent}
        {rightIcons.map(
          (item, i) =>
            item &&
            item.visible !== false && (
              <div key={i} onClick={item.onClick} className="Header__right__icon">
                <div className="Header__right__icon__in">
                  {item.badge && <div className="Header__right__icon__badge" />}
                  {item.icon}
                </div>
              </div>
            ),
        )}
      </Component>
    );
  }

  function renderTitle() {
    if (routeName) {
      return (
        <Link routeName={routeName} routeParams={routeParams} className="Header__title">
          {children}
        </Link>
      );
    } else {
      return <div className="Header__title">{children}</div>;
    }
  }

  const backButton = renderBack();

  return (
    <div
      className={classNames('Header', className, {
        isSearch,
        wide,
        hasBack: backButton,
        isSecondaryBg,
        isTransparent,
        isPrimaryFg,
      })}
    >
      {backButton}
      {renderTitle()}
      {renderRightButton()}
    </div>
  );
};
